import {Component, OnInit} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {FileRecord} from '../model/FileRecord';
import {arrayToStr, strToArray} from './Util';
import {HttpEvent, HttpEventType} from '@angular/common/http';

@Component({
  selector: 'app-dff-file-upload',
  templateUrl: './dff-file-upload.component.html',
  styleUrls: ['./dff-file-upload.component.scss']
})
export class DffFileUploadComponent extends AbstractDynamicFormFieldDirective implements OnInit {

  fileList: FileRecord[] = [];
  maxFileSize: number;

  async ngOnInit() {
    this.maxFileSize = await this.service.loadMaxFileSize();
  }

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {
    const item = strToArray<FileRecord>(value);
    if (item) {
      this.fileList = [...item];
    }
  }

  fileChanged(event) {
    const files: File[] = event.target.files; // it is an object
    this.uploadOneFile(files[0]);
  }

  uploadOneFile(file: File) {
    const localId = new Date().toJSON();
    this.service.uploadFile(file).subscribe(
      event => this.onUpload(event, file.name, localId),
      error => this.onError(error, localId),
      () => this.onComplete()
    );
  }

  private onError(error, localId: string) {
    this.fileList = this.fileList.filter(x => x.localId !== localId);
    throw error;
  }

  private onUpload(event: HttpEvent<string>, fileName: string, localId: string) {
    let fileRecord: FileRecord = this.getFileRecord(localId);
    if (!fileRecord) {
      fileRecord = {
        name: fileName,
        percentDone: 0,
        id: undefined,
        localId,
      };
      this.fileList.push(fileRecord);
    }

    if (event.type === HttpEventType.UploadProgress) {
      fileRecord.percentDone = Math.round(100 * event.loaded / event.total);
    } else if (event.type === HttpEventType.Response) {
      fileRecord.percentDone = 100;
      fileRecord.id = JSON.parse(event.body);
    }
  }

  private onComplete() {
    const records = this.fileList.map(x => ({id: x.id, name: x.name}));
    this.changeValue(arrayToStr(records));
  }

  private getFileRecord(localId: string): FileRecord {
    return this.fileList.find(x => x.localId === localId);
  }

  onDownloadClick(fileId: string) {
    this.service.downloadFile(fileId);
  }

  removeById(id: string) {
    if (this.field.isReadonly) {
      return;
    }
    this.fileList = this.fileList.filter(value => value.id !== id);
    this.changeValue(arrayToStr(this.fileList));
  }

}
